import {seoText} from './catalog-seo.mjs';
export function plantLead(product){
 const description=seoText(product.description);
 if(product.category?.slug==='tomat'){
  const params=Object.fromEntries((product.params||[]).map(p=>[p.name,p.values]));
  const maturity=Array.isArray(params.ripening_time)?params.ripening_time[0]:params.ripening_time;
  const names={'very-early':'Очень ранний томат',early:'Ранний томат','mid-early':'Среднеранний томат',mid:'Томат среднего срока созревания','mid-late':'Среднепоздний томат',late:'Поздний томат','very-late':'Очень поздний томат'};
  const colors={yellow:'жёлтыми',red:'красными',pink:'розовыми',orange:'оранжевыми',green:'зелёными',white:'белыми',black:'чёрными',purple:'фиолетовыми',bicolor:'двухцветными'};
  const color=[].concat(params.color||[]),environments=[].concat(params.environment||[]);
  let lead=names[maturity]||'Томат';
  if(color.length===1&&colors[color[0]])lead+=' с '+colors[color[0]]+' плодами';
  lead+='.';
  const places=[];if(environments.includes('greenhouse'))places.push('теплицы');if(environments.includes('outdoor'))places.push('открытого грунта');if(environments.includes('house'))places.push('выращивания дома');
  if(places.length)lead+=' Для '+places.join(' и ')+(/с подвязкой к опоре/i.test(description)?' с подвязкой к опоре':'')+'.';
  if(names[maturity]||color.length||places.length)return lead;
 }
 const sentences=description.match(/[^.!?]+[.!?]+(?:\s|$)/g)||[];
 const short=sentences.slice(0,2).join(' ').replace(/\s+/g,' ').trim();
 const text=short||description;return text.length>180?text.slice(0,180).replace(/\s+\S*$/,'')+'…':text;
}
